import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "./motion-prims";

const FAQS = [
  {
    q: "Bagaimana cara konfirmasi donasi?",
    a: "Setelah transfer atau scan QRIS, klik tombol “Konfirmasi via WhatsApp” dan kirim bukti transfernya. Tim kami akan membalas dan mencatat donasi Anda di dinding donatur.",
  },
  {
    q: "Apakah ada minimal donasi?",
    a: "Tidak ada batas ketat — namun agar mudah diproses, kami menyarankan mulai dari Rp 10.000 per donasi.",
  },
  {
    q: "Bagaimana penyaluran dananya dilakukan?",
    a: "Dana dikumpulkan, dicatat, lalu disalurkan sesuai program kerja yang dipilih. Laporan penyaluran dibagikan berkala melalui dinding donatur dan media sosial Public Relations 2025.",
  },
  {
    q: "Bisa donasi barang, bukan uang?",
    a: "Sangat bisa. Hubungi kami lewat WhatsApp untuk mengoordinasikan jenis barang, jumlah, dan jadwal pengambilan atau penyerahan.",
  },
];

export default function Faq() {
  return (
    <section id="faq" className="scroll-mt-20 py-20 sm:py-28">
      <div className="mx-auto max-w-3xl px-5 sm:px-8">
        <Reveal className="text-center">
          <p className="text-xs sm:text-sm font-bold uppercase tracking-[0.25em] text-gold-dark">Pertanyaan Umum</p>
          <h2 className="mt-4 font-display font-black tracking-tight leading-tight text-3xl sm:text-4xl lg:text-5xl">
            Masih ragu? <span className="italic text-gold-dark">Wajar, ini jawabannya.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1} className="mt-10">
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="border-ink/20">
                <AccordionTrigger data-testid={`faq-trigger-${i}`} className="font-bold text-base sm:text-lg text-left hover:text-gold-dark hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm sm:text-base text-pine leading-relaxed">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
